import React, { useContext } from 'react';
import SidebarItem from './components/SidebarItem';
import {
	ICustomerFullInfoContext,
	CustomerFullInfoContext,
} from '../../../../../../../../customerFullInfoState/customerFullInfoContext';
import style from './Sidebar.module.scss';

const Sidebar: React.FC = () => {
	const { setStyleGroup, styleData, selectedStyleGroup } =
		useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);

	return (
		<>
			{styleData?.mediaSettings[0]?.groups.length ? (
				<div className={style.container}>
					<SidebarItem
						onClick={() => setStyleGroup({ id: 'colorsID', key: 'colorsKey' })}
						isActive={selectedStyleGroup?.id === 'colorsID'}
						label="colors"
					/>
					{styleData.mediaSettings[0].groups.map((el) => (
						<SidebarItem
							onClick={() => setStyleGroup(el)}
							isActive={selectedStyleGroup?.id === el.id}
							label={el.key}
							key={el.id}
						/>
					))}
					{styleData.documentSettings.map((el) => (
						<SidebarItem
							onClick={() => setStyleGroup({ id: el.id, key: el.key ? el.key : '' })}
							isActive={selectedStyleGroup?.id === el.id}
							label={el.key ? el.key : ''}
							key={el.id}
						/>
					))}
				</div>
			) : null}
		</>
	);
};

export default Sidebar;
